// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"vendors-node_modules_mui_icons-material_AccountBalance_js-node_modules_mui_icons-material_Acc-eafa62":"93dc35c7","src_App_tsx":"f457be12"}[chunkId] + ".chunk.js";
};